import { Col, Row, Space, Table } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { DefaultModal } from "components/Shared/DefaultModal";
import { SearchInput } from "components/Shared/SearchInput";
import { useState } from "react";
import { useIntl } from "react-intl";
import { getPersonRecordKey } from "utils/getPersonRecordKey";
import { usePagedPersons } from "../hooks/usePagedPersons";
import { CreatePersonForm } from "./CreatePersonForm";

type Props = {
  entityId: string;
  title: string;
  disabled: boolean;
  columns: any;
};

export const AddPeople = ({ entityId, title, columns, disabled }: Props) => {
  const { formatMessage } = useIntl();
  const [displaySearchValue, setDisplaySearchValue] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openCreatePersonModal, setOpenCreatePersonModal] = useState(false);

  const { persons, isLoading, pagination, onTableChangedHandler, onSearchTextUpdatedHandler } = usePagedPersons({
    entityId,
    enabled: openModal,
  });

  const onCreatePersonButtonClickHandler = () => {
    setOpenCreatePersonModal(true);
    setOpenModal(false);
  };

  const onCreatePersonCloseHandler = () => {
    setOpenCreatePersonModal(false);
    setOpenModal(true);
  };

  const onPersonCreatedHandler = async (person: any) => {
    setOpenCreatePersonModal(false);

    if (person) {
      setDisplaySearchValue(person.nameFullLocal);
      onSearchTextUpdatedHandler(person.nameFullLocal?.length > 1 ? person.nameFullLocal : "");
    }

    setOpenModal(true);
  };

  const onSearchHandler = (searchText: string) => {
    setDisplaySearchValue(searchText);
    onSearchTextUpdatedHandler(searchText?.length > 1 ? searchText : "");
  };

  return (
    <>
      <DefaultButton onClick={() => setOpenModal(true)} disabled={disabled} icon={<i className={"fa-solid fa-plus"} />}>
        {title}
      </DefaultButton>
      {openModal && (
        <DefaultModal open={openModal} footer={null} onCancel={() => setOpenModal(false)}>
          <Row className="mt-25">
            <Col span={24}>
              <Row justify="end" align="middle" className="pb-15">
                <Space>
                  <SearchInput displayValue={displaySearchValue} onSearch={onSearchHandler} />
                  <DefaultButton onClick={onCreatePersonButtonClickHandler} icon={<i className="fa-solid fa-plus" />}>
                    {formatMessage({ id: "button.newPerson" })}
                  </DefaultButton>
                </Space>
              </Row>
              <Row>
                <Col span={24}>
                  <Table
                    rowKey={getPersonRecordKey}
                    size="small"
                    loading={isLoading}
                    onChange={onTableChangedHandler}
                    pagination={pagination as any}
                    columns={columns}
                    dataSource={persons}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </DefaultModal>
      )}
      {openCreatePersonModal && (
        <DefaultModal open={openCreatePersonModal} footer={null} onCancel={onCreatePersonCloseHandler}>
          <CreatePersonForm entityId={entityId} onCreated={onPersonCreatedHandler} />
        </DefaultModal>
      )}
    </>
  );
};
